module.exports = __webpack_public_path__ + "b2bcf290e73bf621158453a10de145bc.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/bz.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/bz.svg
// module chunks = 0